import React from 'react';
import { useFieldHelper } from 'framework/ui/field';
import { MAP_ENGLISH_LEVEL_TO_SHORT } from 'domain/shared/candidate';
import { Box, Typography } from '@mui/material';

const languageLevelColors: Record<string, string> = {
  A1: 'success.light',
  A2: 'success.light',
  B1: 'text.secondary',
  B2: 'text.secondary',
  C1: 'primary.main',
  C2: 'primary.main',
};

const CandidateEnglishLevelLang = () => {
  // Temporarly we have only one English language.
  const { getValue: getLang } = useFieldHelper({ source: 'englishLevel' });
  const userLang = getLang();
  const userLanguages = [{ name: 'Eng', level: MAP_ENGLISH_LEVEL_TO_SHORT[userLang] }];
  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '3px' }}>
      {userLanguages.map(lang => {
        const langName = typeof lang.name !== 'undefined' ? lang.name : '';
        const langLevel = typeof lang.level !== 'undefined' ? lang.level : '';
        return (
          <Typography
            component="div"
            key={lang.name + lang.level}
            sx={{
              padding: '2px 8px',
              fontSize: '14px',
              fontWeight: 400,
              textAlign: 'center',
              color: 'common.white',
              borderRadius: '3px',
              minWidth: '32px',
              whiteSpace: 'nowrap',
              textTransform: 'uppercase',
              backgroundColor: languageLevelColors[langLevel] || 'success.light',
            }}
          >
            {langName} {langLevel}
          </Typography>
        );
      })}
    </Box>
  );
};

export default CandidateEnglishLevelLang;
